// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by amorales - 25/8/2023

import { Component, HostListener, OnDestroy } from '@angular/core'
import { BaseController } from './base.controller';
import { ADN_PLUS, Action, ApiResponseModel, AuthService,NavbarService, CtButtonComponent, CtButtonCompressedContainerComponent, CtCustomSelect, CtDialogComponent, CtFormComponent, CtInputCheckBoxComponent, CtInputNumberComponent, CtInputTextComponent, CtMessageComponent, CtMessageContainerComponent, CtRadioComponent, CtSelectComponent, CtTableComponent, EntityField, HttpService, MenuService, breakpoints, StoreService } from 'components';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { defaultIfEmpty, take } from 'rxjs/operators';
import { UserOrganizations } from 'components/lib/models/UserOrganizations';

@Component({
  selector: 'pa-vi01',
  template: `<div [id]="getId()" #target><div>`
})

export class PaVi01 extends BaseController implements OnDestroy {

  public numCliente: number;
  public numPlanilla: number;
  public tipPlanilla: string;
  public docIdPatrono: string;

  private readonly PLANILLA_MUTUAL = 'Mutual';
  private readonly PLANILLA_CREDITO = 'Ingreso por deducción';
  private readonly PLANILLA_MUTUAL_CODE = 'M';
  private readonly PLANILLA_MUTUAL_CODE_2 = 'MUT';
  private readonly PLANILLA_CREDITO_CODE = 'C';
  private readonly PLANILLA_CREDITO_CODE_2 = 'CRE';
  private readonly PLANILLA_EST_REVISION = 'Revisión';
  private readonly CONST_SI = 'S';
  private readonly PLANILLA_NO_TIENE_REVISION = 'N';
  private subscriptions : Subscription[] = [];

  constructor(private authService: AuthService, 
    private router: Router,
    private menuService : MenuService) {
    super();
    this.setViewCode('PA_VI01');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  public setNumClienteFromStore(action: Action): void {
    const input: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    const container: CtMessageContainerComponent = this.utilService.getComponentRef(action.conditionParams[1]);

    this.storeService.setState('numCliente', this.authService.loggedUser.user.organization);
    this.storeService.setState('docIdPatrono', this.docIdPatrono);
    const inputUserCode = this.utilService.getComponentRef(action.conditionParams[4]);
    const inputUserId = this.utilService.getComponentRef(action.conditionParams[5]);
    inputUserCode.setValue(this.authService.loggedUser.user.user_code);
    inputUserId.setValue(this.authService.loggedUser.user.user_id);

    this.subscriptions.push(this.storeService.getStateObservable('numCliente').subscribe({
      next: (value) => {
        this.numCliente = value;
        input.setValue(this.numCliente);
      }
    }));
    let adn = this.setADN(this.numCliente);
    this.retPlanPend(adn, container);

    this.checkIfGuidedTour(action);
    this.view.setDescription(`Gestione, consulte y controle toda la información de las planillas de <span class="th-text-main fw-bold">${this.authService.loggedUser.user.organization_name}</span>.`);
  }

  checkIfGuidedTour(action: Action) {
    if(localStorage.getItem('guidedTour') === 'true') {
      this.showGuidedTour(action);
      localStorage.removeItem('guidedTour');
      return;
    }
    const requestData : any = this.getGuidedTourRequest();
    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/MENU/SER_RET_MENU_GUIDED_TOUR_SVA', requestData).subscribe({
      next: (response: ApiResponseModel) => {
        if (response['Data'][0].ArrayEntities.List[0].Value === this.CONST_SI) {
          if(this.checkScreenSize()) return;
          this.showGuidedTour(action);
        } else {
          this.checkIfMultipleOrganizations(action);
        }
      }
    }));
  }

  /**
   * Checks if it's a mobile device, if so, it does not show the guided tour
   * @returns request data for guided tour
   */
  private checkScreenSize() : boolean {
    const screenWidth = window.innerWidth;
    return screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
  }

  markGuidedTourAsCompleted(action : Action) {
    this.fixScreenPosition(false);
    const requestData : any = this.getGuidedTourRequest();
    this.httpService.post(
      HttpService.ENDPOINT + '/api/process/MENU/SER_COMPLETED_GUIDED_TOUR_SVA', requestData
    ).subscribe({
      next: () => {
        const dialog = this.utilService.getComponentRef(action.actionParams[0]);
        dialog.closeDialog();
        this.checkIfMultipleOrganizations(action);
      }
    });
  }

  private checkIfMultipleOrganizations(action: Action) {
    if(this.authService.userOrganizations.length < 2) return;
    this.storeService.getStateObservable('organizationDialogOpen').pipe(
      defaultIfEmpty(false),
      take(1)
    ).subscribe({
      next: (value: boolean) => {
        if(value) {
          this.menuService.menuComponent.getSelectedAdn();
          this.menuService.resetActiveMenuChildByCode(this.viewCode);
          return;
        };
        let dialog : CtDialogComponent;
        if(action.conditionParams.length === 1) dialog = this.utilService.getComponentRef(action.conditionParams[0]);
        else dialog = this.utilService.getComponentRef(action.conditionParams[3]);
        this.addOrganizationsToDialog(dialog);
        setTimeout(() => {
          dialog.ngAfterViewInit();
          dialog.openDialog();
          this.storeService.setState('organizationDialogOpen', true);
        });
      }
    });
  }

  private addOrganizationsToDialog(dialog: CtDialogComponent) {
    const organizationsMetadata : any[] = [];

    this.authService.userOrganizations.forEach((organization: UserOrganizations, index : number) => {
      const data : any = {
        ctType: "CtRadio",
        controlProperties: {
          hidden: false,
          listenedComponentId: "",
          listenedProperty: "",
          border: true,
          isChecked: this.loggedUser.user.organization == organization.numCliente ? true : false,
          readOnly: false,
          labelValue: organization.docIdPat,
          value: organization.numCliente,
          descriptionValue: organization.nomCompleto,
          familyValue: "USER_ORGANIZATIONS",
          id: "ctRadio_organizations_"+index,
          modelId: ""
        },
        controlActions: [{
            displayName: null,
            eventName: "onSelect",
            actionKey: null,
            type: "VIEW",
            action: "setCurrentOrganizationInput",
            isAsync: false,
            actionParams: [
              "ctRadio_organizations_"+index,
              "num_cliente_pat_institution_01"
            ],
            conditionParams: [],
            utilParams: [],
            preAction: null,
            postAction: null,
            params: [],
            actionsFlow: null,
            OperationType: null,
            Entity: null,
            Operation: "setCurrentOrganizationInput",
            Endpoint: null
        }],
        models: []
      }
      organizationsMetadata.push(data);
    });
    const metadata : any = dialog.getMetaData();
    metadata.models = organizationsMetadata;
    dialog.setMetaData(metadata);
  }

  setCurrentOrganizationInput(action : Action){
    const radio : CtRadioComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const input : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
    input.setValue(radio.getValue());
  }

  checkIfSwitchIsNeeded(action : Action): boolean {
    const input : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
    if((input.getValue() == null || input.getValue() === '' || input.getValue() == undefined) ||
        (this.authService.loggedUser.user.organization == input.getValue())){
      dialog.closeDialog();
      return false; 
    }
  }

  managePostOrganizationSwitch(action : Action) {
    const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
    this.refreshUser(action);
    this.view.getChildsByType(CtRadioComponent,true).forEach((radio: CtRadioComponent) => {
      if(radio.getIsChecked()){
        const titleCasedName = this.authService.userOrganizations.find(
          organization => organization.numCliente === radio.getValue()
        )?.nomCompleto.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
        this.view.setDescription(`Gestione, consulte y controle toda la información de las planillas de <span class="th-text-main fw-bold">${titleCasedName}</span>.`);
        this.authService.loggedUser.user.organization_name = titleCasedName;
      }
    });
    this.refreshCurrentPage();
    dialog.closeDialog();
    this.menuService.menuComponent.getSelectedAdn();
    this.menuService.resetActiveMenuChildByCode(this.viewCode);
    return true;
  }

  private refreshCurrentPage() {
    super.ngAfterViewInit();
  }

  private refreshUser(action: Action) {
    const input : CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
    this.authService.refreshUserAfterOrganizationChange(input.getValue());
  }

  private showGuidedTour(action: Action) {
    this.fixScreenPosition(true);
    const guidedTour: CtDialogComponent = this.utilService.getComponentRef(action.conditionParams[2]);
    guidedTour.openDialog();
  }

  private fixScreenPosition(fixed : boolean) {
    const html = document.querySelector('html');
    html.scrollTop = 0;
    if (fixed) {
      html.style.overflowY = 'hidden';
    } else {
      html.style.overflowY = 'scroll';
    }
  }

  public loadMessageContainerPagoPend(action: Action){
    const messageContainerPendPago: CtMessageContainerComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let adn = this.setADN(this.numCliente);
    if(this.authService.getUserRoles().includes('TESORERIA_PLANILLAS')){
      this.retPlanPendPago(adn,messageContainerPendPago);
    }
  }


  public loadPlanillasTable(action: Action) {
    let tablePlanillas: CtTableComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
    let numPlanillaInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
    let tipPlanillaCreInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[3]).getValue();
    let tipPlanillaMutInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[4]).getValue();
    let estPlanillaReInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[5]).getValue();
    let estPlanillaPpInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[6]).getValue();
    let estPlanillaPrInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[7]).getValue();
    let estPlanillaApiInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[10]).getValue();
    let estPlanillaCarInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[11]).getValue();
    let fecInicioInput: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[8]).getValue();
    let fecFinalInput: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[9]).getValue();

   this.subscriptions.push(this.getPlanillasPatron(numClienteInput, numPlanillaInput, tipPlanillaCreInput, tipPlanillaMutInput, estPlanillaReInput, estPlanillaPpInput,
      estPlanillaPrInput, fecInicioInput, fecFinalInput, estPlanillaApiInput, estPlanillaCarInput).subscribe({
        next: (response: ApiResponseModel) => {
          this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);
        },
        error: (err: any) => {
          this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
            true, 'Aceptar', 'Cancelar');
        }
      }));
  }

  private getTablePlanillas(numCliente: CtInputNumberComponent, num_planilla: CtInputNumberComponent, tip_planilla_cre: CtInputCheckBoxComponent,
    tip_planilla_mut: CtInputCheckBoxComponent, est_planilla_re: CtInputCheckBoxComponent, est_planilla_pp: CtInputCheckBoxComponent,
    est_planilla_pr: CtInputCheckBoxComponent, fec_inicio: CtCustomSelect, fec_final: CtCustomSelect,
    estPlanillaApiInput: CtInputCheckBoxComponent, estPlanillaCarInput: CtInputCheckBoxComponent): any {

    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [
          {
            "Name": "NUM_PLANILLA",
            "Alias": "NUM_PLANILLA",
            "Value": num_planilla

          },
          {
            "Name": "NUM_CLIENTE",
            "Alias": "NUM_CLIENTE",
            "Value": numCliente
          },
          {
            "Name": "TIP_PLANILLA_CRE",
            "Alias": "TIP_PLANILLA_CRE",
            "Value": tip_planilla_cre
          },
          {
            "Name": "TIP_PLANILLA_MUT",
            "Alias": "TIP_PLANILLA_MUT",
            "Value": tip_planilla_mut
          },
          {
            "Name": "ESTADO_PLANI_RE",
            "Alias": "ESTADO_PLANI_RE",
            "Value": est_planilla_re
          },
          {
            "Name": "ESTADO_PLANI_PP",
            "Alias": "ESTADO_PLANI_PP",
            "Value": est_planilla_pp
          },
          {
            "Name": "ESTADO_PLANI_PR",
            "Alias": "ESTADO_PLANI_PR",
            "Value": est_planilla_pr
          },

          {
            "Name": "ESTADO_PLANI_API",
            "Alias": "ESTADO_PLANI_API",
            "Value": estPlanillaApiInput
          },
          {
            "Name": "ESTADO_PLANI_CAR",
            "Alias": "ESTADO_PLANI_CAR",
            "Value": estPlanillaCarInput
          },

          {
            "Name": "FEC_INICIO",
            "Alias": "FEC_INICIO",
            "Value": fec_inicio
          },
          {
            "Name": "FEC_FINAL",
            "Alias": "FEC_FINAL",
            "Value": fec_final
          }
        ]
      },
      "Data": []
    }
  }

  public getPlanillasPatron(numClienteInput: CtInputNumberComponent, numPlanillaInput: CtInputNumberComponent, tipPlanillaCreInput: CtInputCheckBoxComponent,
    tipPlanillaMutInput: CtInputCheckBoxComponent, estPlanillaReInput: CtInputCheckBoxComponent, estPlanillaPpInput: CtInputCheckBoxComponent,
    estPlanillaPrInput: CtInputCheckBoxComponent, fecInicioInput: CtCustomSelect, fecFinalInput: CtCustomSelect,
    estPlanillaApiInput: CtInputCheckBoxComponent, estPlanillaCarInput: CtInputCheckBoxComponent): Observable<any> {
    const requestData: any = this.getTablePlanillas(numClienteInput, numPlanillaInput, tipPlanillaCreInput, tipPlanillaMutInput, estPlanillaReInput,
      estPlanillaPpInput, estPlanillaPrInput, fecInicioInput, fecFinalInput, estPlanillaApiInput, estPlanillaCarInput);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_DET_PLAN_REC', requestData);
  }

  public setADN(numCliente: number): any {
    let contRequest = {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_CLIENTE",
          "Alias": "NUM_CLIENTE",
          "Value": numCliente,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        },
        ]
      },
      "Data": [],
      "Files": []
    }
   return contRequest;
  }

  private retPlanPend(contRequest: any , container: CtMessageContainerComponent){
      this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS_PENDIENTES/SER_RET_PLAN_PEN', contRequest).subscribe({
         next: (response: ApiResponseModel) => {
           container.setValue(response['Data']);
           this.getTipPlanilla(response);
           this.getNumPlanilla(response);
         },
         error: (error: any) => {
           container.setValue(error);
         }
       })); 
  }

  private retPlanPendPago(contRequest: any, messageContainerPendPago: CtMessageContainerComponent){
    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS_PENDIENTES/SER_RET_PLAN_PEND_PAGO', contRequest).subscribe({
      next: (response: ApiResponseModel) => {
        messageContainerPendPago.setValue(response['Data']);
      },
      error: (error: any) => {
        messageContainerPendPago.setValue(error);
      }
    })); 
  }

  private getTipPlanilla(result: ApiResponseModel): string {

    result['Data'][0]['ArrayEntities']['List'].forEach((entity: EntityField) => {
      if (entity.Name === 'TIP_PLANILLA') this.tipPlanilla = entity.Value;
    });
    return this.tipPlanilla;
  }

  private getNumPlanilla(result: ApiResponseModel): number {
    result['Data'][0]['ArrayEntities']['List'].forEach((entity: EntityField) => {
      if (entity.Name === 'NUM_PLANILLA') this.numPlanilla = parseInt(entity.Value);
    });
    return this.numPlanilla;
  }


  public redirectToPA_VI03_Ex(action: Action): void {
    this.storeService.setState('organizationId', this.authService.loggedUser.user.organization);
    this.storeService.setState('tipoPresentacion','Extraordinaria');
    this.storeService.deleteState('isEditing');
    this.router.navigate(['home/view/PA_VI03']);
  }

  public redirectToPA_VI03_Nu(action: Action): void {
    this.storeService.setState('organizationId', this.authService.loggedUser.user.organization);
    this.storeService.deleteState('isEditing');
    this.storeService.setState('tipoPresentacion','Nueva');
    this.router.navigate(['home/view/PA_VI03']);
  }

  /*
  * @param tipoPlanilla
  * @returns boolean
  * @description: Busca si existen planillas en estado revisión para el tipo de planilla seleccionado, esto lo usa para en la PA_VI03 mostrar un mensaje de confirmación
  * antes de presentar la planilla. esto con el fin de evitar que el usuario le caiga encima a los datos que ya tiene en revisión.
  */
  private getPlanillaRevisionFromTable(tipoPlanilla: string, action: Action): any {
    const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const planillaRevision = table.getRows().filter((row: any) => row.fields['EST_PLANILLA'].value === this.PLANILLA_EST_REVISION);
    const result = planillaRevision.filter((row: any) =>
      row.adnSource.ArrayEntities.List.find((entity: any) =>
        entity.Name === 'TIP_DEDUCCION' && entity.Value === tipoPlanilla) !== undefined).length > 0 ? true : false;
    return result;
  }

  public downloadReport(action: Action): void {
    const form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
    let tipPlanilla: string = form.getFormControl('RAW_TIP').value.RAW_TIP;
    tipPlanilla = tipPlanilla === 'MUT' ? 'M' : 'C';
    const reportData = this.getReportData(Number(this.numPlanilla), tipPlanilla);
    let nombreTipPlanilla : string;
    if(tipPlanilla = 'M'){
      nombreTipPlanilla = 'póliza mutual'
    }else { nombreTipPlanilla ='crédito'}
    this.requestReportData(reportData,'pdf',`Planilla de ${nombreTipPlanilla}`);
  }

  public downloadReportCredCobro(action: Action): void {
    let numPatrono = this.authService.loggedUser.user.organization;
    const periodoCobro : CtCustomSelect = this.utilService.getComponentRef(action.actionParams[0]);
    const dialogToClose: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);

    let periodoCobroSelected: number | null = Number(periodoCobro.getValue());
      if(periodoCobroSelected === 0){
        periodoCobroSelected = null;
      }
      const reportDataPDF = this.getReportCredCobro(numPatrono, periodoCobroSelected);
      const reportDataExcel = this.getReportCredCobroExcel(numPatrono, periodoCobroSelected);
      if(periodoCobroSelected == null){
        periodoCobroSelected = periodoCobro.options[0].value;
      }
      this.requestCredCobro(reportDataPDF,'pdf',`Cobro de créditos ${periodoCobroSelected}`);
      this.requestCredCobroExcel(reportDataExcel, 'excel',`Cobro de créditos ${periodoCobroSelected}`);
      dialogToClose.closeDialog();
  }


  private messageValidationForm(message): void {
    this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message ,true, 'Aceptar', 'Cancelar');
  }

  private isFieldEmpty(element: CtCustomSelect ): boolean {
      return element.getValue() === '' || element.getValue() === null;
  }

  private getReportCredCobro(numCliente: number, numPeriodo: number): any {
    return {
      "format": "PDF",
      "source": this.getViewCode(),
      "sendTo": null,
      "requireDownloadURL": false,
      "parameters": [
        {
          "name": "P_NUM_CLIENTE",
          "value": numCliente
        }
        ,{
           "name": "P_PER_COBRO",
           "value": numPeriodo
         }
      ]
    };
  }

  private getReportCredCobroExcel(numCliente: number, numPeriodo: number): any {
    return {
      "format": "XLS",
      "source": this.getViewCode(),
      "sendTo": null,
      "requireDownloadURL": false,
      "parameters": [
        {
          "name": "P_NUM_CLIENTE",
          "value": numCliente
        }
         ,{
           "name": "P_PER_COBRO",
          "value": numPeriodo
          }
      ]
    };
  }

  private getReportData(numPlanilla: number, tipPlanila: string): any {
    return {
      "format": "PDF",
      "source": this.getViewCode(),
      "sendTo": null,
      "requireDownloadURL": false,
      "parameters": [
        {
          "name": "P_NUM_PLAN",
          "value": numPlanilla
        },
        {
          "name": "P_TIP_PLAN",
          "value": tipPlanila
        },
        {
          "name": "P_USER_CODE",
          "value": this.authService.loggedUser.user.user_code
        }
      ]
    };
  }

  private getReportDataRev(tipPlanila: string, docIdPatrono: string): any {
    return {
      "format": "XLS",
      "source": this.getViewCode(),
      "sendTo": null,
      "requireDownloadURL": false,
      "parameters": [
        {
          "name": "P_TIP_PLANILLA",
          "value": tipPlanila.toUpperCase() === 'M' ? 'MUT' : 'CRE'

        },
        {
          "name": "P_DOC_ID_PAT",
          "value": docIdPatrono
        },
        {
          "name": "P_USER_CODE",
          "value": this.authService.loggedUser.user.user_code
        }

      ]
    };
  }

  private requestReportData(reportData: any, fileType: string , fileName: string) {
   this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_RE06', reportData).subscribe({
      next: (data: any) => {
        const report: any = data.data[0];
        this.componentService.utl_downloadReport(report, fileType, fileName);
      },
      error: (error: any) => {
        this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
          'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
          true, 'Finalizar', 'Cancelar');
      }
    }));
  }

  private requestReportDataRev(reportData: any, fileType: string , fileName: string) {
    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_FX36', reportData).subscribe({
      next: (data: any) => {
        const report: any = data.data[0];
        this.componentService.utl_downloadReport(report, fileType, fileName);
      },
      error: (error: any) => {
        this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
          'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
          true, 'Finalizar', 'Cancelar');
      }
    }));
  }

  private requestCredCobro(reportData: any, fileType: string , fileName: string) {
    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_RE54', reportData).subscribe({
       next: (data: any) => {
         const report: any = data.data[0];
         this.componentService.utl_downloadReport(report, fileType, fileName);
       },
       error: (error: any) => {
         this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
           'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
           true, 'Finalizar', 'Cancelar');
       }
     }));
   }

   private requestCredCobroExcel(reportData: any, fileType: string , fileName: string) {
    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_FX38', reportData).subscribe({
       next: (data: any) => {
         const report: any = data.data[0];
         this.componentService.utl_downloadReport(report, fileType, fileName);
         this.plusAlertService.setCtDialogInfo('Reportes descargados', 'success', 'success', 'primary', 'Visualice en la carpeta de descargas de su dispositivo los reportes seleccionados.',
        true, 'Finalizar', '');
        let buttonSiguiente:CtButtonComponent = this.utilService.getComponentRef('PA_VI01_btnReportesPaso1');
        let radioSelected: CtRadioComponent = this.utilService.getComponentRef('ctrCtRadio_7d7ad5e8_81fee140_91');
        let periodSelect:  CtCustomSelect = this.utilService.getComponentRef('CtCustomSelect_9b6de72e_REPORTES');
        buttonSiguiente.setDisabled(true);
        radioSelected.clearSelectionVisual();
        periodSelect.manageFilterContainerSelectClickWhenIsClosed();
       },
       error: (error: any) => {
         this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
           'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
           true, 'Finalizar', 'Cancelar');
       }
     }));
   }

  /**
   * Hides actions from every row in the table based on the row's planilla status
   * @param action
   */
  public hideRowActions(action: Action): void {
    const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
    table.rowsButtonContainer.forEach((rowButtonContainer: any) => {
      const planillaStatus: string = rowButtonContainer.row.fields['EST_PLANILLA'].value;
      this.hideButtonsByRowStatus(planillaStatus.toUpperCase(), rowButtonContainer.buttonContainer[0]);
    })
  }

  /**
   * @param planillaStatus status of the current selected row
   * @param buttonContainer buttons of the current selected row
   */
  private hideButtonsByRowStatus(planillaStatus: string, buttonContainer: CtButtonCompressedContainerComponent): void {
    switch (planillaStatus) {
      case 'PAGO PENDIENTE':
        //commented to remove the payment functionality temporarily
        //this.hideButtonContainerButtonsByStatus(buttonContainer,['DESCARGAR','EDITAR','PAGAR','DETALLE']);
        this.hideButtonContainerButtonsByStatus(buttonContainer, ['DESCARGAR', 'DETALLE']);
        break;
      case 'PRESENTADA':
        this.hideButtonContainerButtonsByStatus(buttonContainer, ['DESCARGAR', 'DETALLE']);
        break;
      case 'REVISIÓN':
        //commented to remove the payment functionality temporarily
        this.hideButtonContainerButtonsByStatus(buttonContainer, ['DESCARGAR', 'EDITAR', 'DETALLE']);
        //this.hideButtonContainerButtonsByStatus(buttonContainer,['DESCARGAR','DETALLE']);
        break;
      case 'CARGADA':
        this.hideButtonContainerButtonsByStatus(buttonContainer, ['DESCARGAR', 'DETALLE']);
        break;
      case 'APLICADA':
        this.hideButtonContainerButtonsByStatus(buttonContainer, ['DESCARGAR', 'DETALLE']);
        break;
      default:
        this.hideButtonContainerButtonsByStatus(buttonContainer, []);
        break;
    }
  }

  private hideButtonContainerButtonsByStatus(buttonContainer: CtButtonCompressedContainerComponent, modelIdsToShow: string[]) {
    buttonContainer.getChildElements().forEach((button: CtButtonComponent) => {
      if (!modelIdsToShow.includes(button.getModelId())) button.setHidden(true);
    })
  }

  /**
   * When the button ">" is clicked
   * @param action 
   */
  public goToDetail(action: Action): void {
    const value: ADN_PLUS = this.getSelectedAdnFromTable(action);
    const numPlanilla = value.getStringAttribute('NUM_PLANILLA');
    const tipPlanilla = value.getStringAttribute('TIP_DEDUCCION')
      .toUpperCase() === 'MUTUAL' ? 'MUT' : 'CRE';
    const idPatrono = value.getStringAttribute('DOC_IDENTIFICACION');
    this.storeService.setState('numPlanilla', numPlanilla);
    this.storeService.setState('tipPlanilla', tipPlanilla);
    this.storeService.setState('docIdPatrono', idPatrono);
    this.router.navigate(['home/view/PA_VI02']);
  }

  public downloadReportFromTable(action: Action): void {
    const { numPlanilla, tipPlanilla, periodoFormated } = this.extractTableDataForReport(action) || {};
    if (numPlanilla != '0') {
      const reportData = this.getReportData(Number(numPlanilla), tipPlanilla);
      let nameTipPlanilla : string;
      if(tipPlanilla== 'M'){
        nameTipPlanilla = 'póliza mutual'
      } else nameTipPlanilla = 'crédito'
      this.requestReportData(reportData,'pdf', `Planilla de ${nameTipPlanilla} ${periodoFormated}`);
    }
  }

  public goToPaymentScreen(action: Action): void {
    const { numPlanilla, idPatrono } = this.extractTableData(action);
    this.storeService.setState('numPlanilla', numPlanilla);
    this.storeService.setState('docIdPatrono', idPatrono);
    this.router.navigate(['home/view/PA_VI04']);
  }

  private extractTableData(action: Action): { numPlanilla: string, idPatrono: string } {
    const value: ADN_PLUS = this.getSelectedAdnFromTable(action);
    const numPlanilla = value.getStringAttribute('NUM_PLANILLA');
    const idPatrono = value.getStringAttribute('DOC_IDENTIFICACION');
    return { numPlanilla, idPatrono };
  }
  
  private convertMonthYearToYearMonth(input: string): string {
		const upperInput = input.toUpperCase();
		const monthMap: { [key: string]: string } = {
			'ENERO': '01', 'FEBRERO': '02', 'MARZO': '03', 'ABRIL': '04', 'MAYO': '05', 'JUNIO': '06',
			'JULIO': '07', 'AGOSTO': '08', 'SEPTIEMBRE': '09', 'OCTUBRE': '10', 'NOVIEMBRE': '11', 'DICIEMBRE': '12'
		  };
		const parts = upperInput.split(' - ');
		const month = parts[0];
		const year = parts[1];
	
		return `${year}${monthMap[month]}`;
	  }

  private extractTableDataForReport(action: Action): { numPlanilla: string, tipPlanilla: string, periodoFormated: any } {
    const value: ADN_PLUS = this.getSelectedAdnFromTable(action);
    const numPlanilla = value.getStringAttribute('NUM_PLANILLA');
    const tipPlanilla = value.getStringAttribute('TIP_DEDUCCION').toUpperCase() === 'MUTUAL' ? 'M' : 'C';
    const estPlanilla = value.getStringAttribute('EST_PLANILLA');
    const idPatrono = value.getStringAttribute('DOC_IDENTIFICACION');
    let periodo = value.getStringAttribute('PER_PAGO_PATRONO');
    let periodoFormated = this.convertMonthYearToYearMonth(periodo);

    if (estPlanilla === 'Revisión') {
      const reportData = this.getReportDataRev(tipPlanilla, idPatrono);
      let nameTipPlanilla : string;
      if(tipPlanilla== 'M'){
        nameTipPlanilla = 'póliza mutual'
      } else nameTipPlanilla = 'crédito'
      this.requestReportDataRev(reportData,'excel',`Planilla de ${nameTipPlanilla} en revisión ${periodoFormated}`);
      return { numPlanilla, tipPlanilla, periodoFormated};
    } else {
      return { numPlanilla, tipPlanilla, periodoFormated};
    }
  }

  private getSelectedAdnFromTable(action: Action): ADN_PLUS {
    const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
    return table.getSelectedAdn();
  }

  public goToEditScreen(action: Action): void {
    const { numPlanilla, idPatrono } = this.extractTableData(action);
    const { tipPlanilla } = this.extractTableDataForReport(action);
    this.storeService.setState('numPlanilla', numPlanilla);
    this.storeService.setState('docIdPatrono', idPatrono);
    this.storeService.setState('isEditing', true);
    this.storeService.setState('tipPlanilla', tipPlanilla);
    this.storeService.setState('periodoPlanilla', this.getSelectedAdnFromTable(action).getStringAttribute('PER_PAGO_PATRONO'));
    this.router.navigate(['home/view/PA_VI03']);
  }

  public executePresentarByMessagePreAction(action: Action) {
    const ctDialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const dialogAction: Action = ctDialog.getControlActions()[0];
    const message: CtMessageComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    dialogAction.conditionParams[0] = action.conditionParams[0];
    ctDialog.setControlActions([dialogAction]);

   this.subscriptions.push(this.executeValidatePlanillaPendienteRequest(
    this.extractMessageData(message).idPatrono, this.extractMessageData(message).tipPlanilla)
      .subscribe({
        next: (response: ApiResponseModel) => {
          const tieneRevision = response['Data'][0].ArrayEntities.List.find(
            (entity: EntityField) => entity.Name === 'IND_TIENE_REVISION').Value;
          if (tieneRevision === this.CONST_SI) {
            ctDialog.openDialog();
          } else {
            ctDialog.event2('onClick');
          }
        },
        error: (error: any) => {
          this.plusAlertService.setCtDialogInfo('Error al validar planillas en revisión', 'error',
            'error', 'primary', error.description,
            true, 'Finalizar', 'Cancelar');
        }
      }));
  }

  private extractMessageData(ctMessage: CtMessageComponent): { idPatrono: any; tipPlanilla: any; numPlanilla: any;  } {
    let idPatrono;
    let tipPlanilla;
    let numPlanilla;
    ctMessage.getValue().ArrayEntities.List.forEach((entity: EntityField) => {
      if (entity.Name === 'ID_DOC_PATRONO') idPatrono = entity.Value;
      if (entity.Name === 'TIP_PLANILLA') tipPlanilla = entity.Value;
      if (entity.Name === 'NUM_PLANILLA') numPlanilla = entity.Value;
    });
    return { idPatrono, tipPlanilla, numPlanilla };
  }

  public redirectToPA_VI03FromMessaCont(action: Action): void {
    const dialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const message: CtMessageComponent = this.utilService.getComponentRef(dialog.getControlActions()[0].conditionParams[0]);
    this.loadPlanillaByMessage(message);
  }

  private loadPlanillaByMessage(ctMessage: CtMessageComponent) {
    const { idPatrono, tipPlanilla } = this.extractMessageData(ctMessage);
    this.subscriptions.push(this.executeLoadPlanillaByMessageRequest(idPatrono, tipPlanilla)
      .subscribe({
        next: (response: ApiResponseModel) => {
          this.storeService.setState('isEditing', true);
          let numPlanilla;
          let idPatrono;
          let periodoPlanilla;
          ctMessage.getValue().ArrayEntities.List.forEach((entity: EntityField) => {
            if (entity.Name === 'TIP_PLANILLA') this.tipPlanilla = entity.Value;
            if (entity.Name === 'ID_DOC_PATRONO') idPatrono = entity.Value;
            if (entity.Name === 'PER_PAGO_PAT') periodoPlanilla = entity.Value;
            if (entity.Name === 'NUM_PLANILLA') numPlanilla = parseInt(entity.Value);
          });
          this.storeService.setState('numPlanilla', numPlanilla);
          this.storeService.setState('docIdPatrono', idPatrono);
          this.storeService.setState('periodoPlanilla', periodoPlanilla);
          this.storeService.setState('tipPlanilla', this.tipPlanilla);
          this.router.navigate(['home/view/PA_VI03']);
        },
        error: (error: any) => {
          this.plusAlertService.setCtDialogInfo('Error al cargar la planilla', 'error',
            'error', 'primary', error.description,
            true, 'Finalizar', 'Cancelar');
        }
      }));
  }

  private executeLoadPlanillaByMessageRequest(idPatrono: any, tipPlanilla: any): Observable<any> {
    const requestData: any = this.getLoadPlanillaRequestData(idPatrono, tipPlanilla);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_CARGA_PLANILLA_WEB_2', requestData);
  }

  private executeValidatePlanillaPendienteRequest(idPatrono: any, tipPlanilla: any): Observable<any> {
    const requestData: any = this.getLoadPlanillaRequestData(idPatrono, tipPlanilla);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_VALIDATE_PLANILLA_PEN_SMS', requestData);
  }

  // Custom Select
  private setCustomSelects(action: Action): void {
    let selectDesde: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[0]);
    let selectHasta: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[1]);
    let selectPeriodoReportes: CtCustomSelect = this.utilService.getComponentRef(action.conditionParams[2]);
    this.setSelectCobroCred(selectPeriodoReportes);
    this.subscriptions.push(this.getListPeriodos().subscribe({
      next: (response: ApiResponseModel) => {
        let adnList = response['Data'];
        let optionsDesde = this.utilService.convertAdnToSelectOptions(adnList, selectDesde.getFieldValue(), selectDesde.getFieldText());
        let optionsHasta = this.utilService.convertAdnToSelectOptions(adnList, selectHasta.getFieldValue(), selectHasta.getFieldText());
        if (optionsDesde.length == 0) {
          optionsDesde = [{ text: 'No hay periodos para filtrar', value: null }]
          optionsHasta = [{ text: 'No hay periodos para filtrar', value: null }]
        }
        selectDesde.options = optionsDesde;
        selectHasta.options = optionsHasta;
      }
    }));
  }

  private setSelectCobroCred(select: CtCustomSelect){
    this.subscriptions.push(this.getListPerCobroCred().subscribe({
      next: (response: ApiResponseModel) => {
        let adnList = response['Data'];
        let options = this.utilService.convertAdnToSelectOptions(adnList,select.getFieldValue(), select.getFieldText());
        if(options.length == 0){
          options = [{ text: 'No hay periodos para filtrar', value: null }]
        }
        select.options = options;
      }
    }));
  }

  private getListPerCobroCred(): Observable<any>{
    let numPatrono = this.authService.loggedUser.user.organization;
    const requestData: any = this.getListaMetadata(numPatrono);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/GENERACION_COBRO/SER_RET_PER_COBRO_PATRONO', requestData);
  }

  private getListPeriodos(): Observable<any> {
    let numPatrono = this.authService.loggedUser.user.organization;
    const requestData: any = this.getListaMetadata(numPatrono);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_LST_PERIODOS', requestData);
  }

  private getListaMetadata(numPatrono) {
    let contRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_PATRONO",
          "Alias": "NUM_PATRONO",
          "Value": numPatrono,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        },
        ]
      },
      "Data": []
    }

    return contRequest;
  }

  getLoadPlanillaRequestData(idPatrono: any, tipPlanilla: any): any {
    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions": {
        "Data": [
          {
            "Name": "DOC_IDENTIFICACION",
            "Alias": "DOC_IDENTIFICACION",
            "Value": idPatrono
          },
          {
            "Name": "TIP_PLANILLA",
            "Alias": "TIP_PLANILLA",
            "Value": tipPlanilla === this.PLANILLA_MUTUAL_CODE ?
              this.PLANILLA_MUTUAL_CODE_2 : this.PLANILLA_CREDITO_CODE_2
          },
          {
            "Name": "PM_VI00",
            "Alias": "PM_VI00",
            "Value": "PA_VI03" //to simulate the PA_VI03 behavior in the BD service
          }
        ]
      },
      "Data": [],
      "Params": null
    }
  }

  getGuidedTourRequest(): any {
    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions": {
        "Data": [
          {
            "Name": "USER_ID",
            "Alias": "USER_ID",
            "Value": this.authService.loggedUser.user.user_id
          },
          {
            "Name": "USER_CODE",
            "Alias": "USER_CODE",
            "Value": this.authService.loggedUser.user.user_code
          }
        ]
      },
      "Data": [],
      "Params": null
    }
  }

  //Reportes controls

  
  // pago desde el ctmessageContainer del rol de planillas

  private realizarPagoFromMessage(action: Action){
    const message: CtMessageComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let numPlanilla = this.extractMessageData(message).numPlanilla;
    let idPatron = this.extractMessageData(message).idPatrono;

    this.storeService.setState('numPlanilla', numPlanilla);
    this.storeService.setState('docIdPatrono', idPatron);
    this.router.navigate(['home/view/PA_VI04']);
}

  /* -------------------- END CONTROLLER LOGIC ----------------- */
}
